import { useState, useEffect } from 'react';
import { User, onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';

export interface AuthState {
  user: User | null;
  loading: boolean;
}

const DEMO_MODE = import.meta.env.VITE_DEMO_MODE === 'true';

/**
 * Subscribes to Firebase Auth state changes and returns the current user
 * along with a loading flag that is `true` while the initial auth check is
 * in progress.
 */
export function useAuth(): AuthState {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (DEMO_MODE) {
      setUser({ uid: 'demo', email: 'demo@prelaunchwaitlist.com' } as User);
      setLoading(false);
      return;
    }

    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  return { user, loading };
}
